import styled from 'styled-components';

export const StickyArticleHeaderWrapper = styled.div`
  position: sticky;
  z-index: 99;
  top: 64px;
  @media (min-width: 768px) {
    top: 76px;
  }
  @media (min-width: 1024px) {
    top: 72px;
  }

  [class*='Blockstyle__Block-sc-'] {
    display: flex;
    padding: 1.25rem;

    [class*='Blockstyle__ContentWrapper-sc'] {
      min-width: min(638px, 100%);
      display: block;
      @media (min-width: 768px) {
        min-width: initial;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4.5rem;
      }

      @media (min-width: 768px) and (max-width: 980px) {
        gap: 1rem;
      }

      & > *:first-child {
        display: none;
        @media (min-width: 768px) {
          display: initial;
        }
      }

      [class*='CtaButtonRow___Styled'] {
        padding-top: 0;
        padding-bottom: 0.5rem;

        button {
          line-height: 20px;
        }

        @media (min-width: 768px) {
          padding: 0;
        }

        [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
          width: 100%;
          [class*='CtaButtonRow___StyledDiv-'] {
            width: 100%;
          }
        }
      }
    }
  }

  color: #ffffff;
`;

export const SocialMediaWrapper = styled.div``;
